<template>
  <PageLayout title="Formuláře">
    <section class="mb-6">
      <h2 class="text-h3 mb-2 font-weight-bold">Text field</h2>
      <v-row>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Empty
          </div>
          <v-text-field outlined label="Název reklamy" hide-details="auto" />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Empty with placeholder
          </div>
          <v-text-field
            outlined
            label="Název reklamy"
            placeholder="Zadejte název reklamy"
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Filled
          </div>
          <v-text-field
            outlined
            label="Název reklamy"
            value="Moje super reklama"
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Empty – disabled
          </div>
          <v-text-field
            outlined
            label="Název reklamy"
            hide-details="auto"
            disabled
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Empty with placeholder – disabled
          </div>
          <v-text-field
            outlined
            label="Název reklamy"
            placeholder="Zadejte název reklamy"
            hide-details="auto"
            disabled
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Filled – disabled
          </div>
          <v-text-field
            outlined
            label="Název reklamy"
            value="Moje super reklama"
            hide-details="auto"
            disabled
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Error
          </div>
          <v-text-field
            outlined
            label="Název reklamy"
            placeholder="Rek"
            hide-details="auto"
            error
            hint="Název reklamy musí mít alespoň 8 znaků"
            persistent-hint
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Persistent hint &amp; counter
          </div>
          <v-text-field
            outlined
            label="Název reklamy"
            hide-details="auto"
            hint="Název reklamy se zobrazí ve výpisu"
            value="Moje reklama"
            persistent-hint
            counter="30"
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            With suffix
          </div>
          <v-text-field
            outlined
            label="Rozpočet"
            value="200"
            hide-details="auto"
            suffix="Kč"
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            With icon prepended
          </div>
          <v-text-field
            outlined
            placeholder="Hledejte příspěvek"
            prepend-inner-icon="mdi-magnify"
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Clearable
          </div>
          <v-text-field
            outlined
            hide-details="auto"
            value="Příspěvek"
            clearable
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Deletable
          </div>
          <v-text-field
            outlined
            hide-details="auto"
            value="Příspěvek"
            clearable
            class="c-input--append-button"
          >
            <template #append-outer>
              <v-btn icon color="red">
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Password
          </div>
          <v-text-field
            outlined
            hide-details="auto"
            label="Heslo"
            value="loremipsum"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Date
          </div>
          <ui-date-picker />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Time
          </div>
          <ui-time-picker />
        </v-col>
      </v-row>
    </section>

    <section class="mb-6">
      <h2 class="text-h3 font-weight-bold mb-2">Select</h2>
      <v-row>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Single
          </div>
          <v-select
            outlined
            hide-details="auto"
            label="Publikum stávajících okruhů uživatelů"
            :items="items"
          />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Multiple
          </div>
          <v-select
            outlined
            hide-details="auto"
            label="Publikum stávajících okruhů uživatelů"
            multiple
            :items="items"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" lg="4" xl="3">
          <div class="text-overline mb-4 navy--text text--lighten-1">
            Dense
          </div>
          <v-select
            outlined
            dense
            :items="items"
            placeholder="Vyberte teplotu"
            hide-details
            class="overline font-weight-bold c-input--align-prepend-inner-center"
          >
            <template #prepend-inner>
              <icon-pigments-all class="align-self-center mr-1" />
            </template>
          </v-select>
        </v-col>
      </v-row>
    </section>

    <section class="mb-6">
      <h2 class="text-h3 font-weight-bold mb-2">Toggles</h2>
      <v-row>
        <v-col cols="12" md="6" lg="4">
          <v-checkbox hide-details="auto" label="Unchecked" />
          <v-checkbox hide-details="auto" value label="Checked" />
          <v-checkbox hide-details="auto" indeterminate label="Indeterminate" />
          <v-checkbox hide-details="auto" disabled label="Disabled" />
          <v-checkbox
            hide-details="auto"
            error
            hint="Něco je špatně"
            persistent-hint
            label="Error"
          />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <v-radio-group v-model="radioGroup">
            <v-radio v-for="n in 3" :key="n" :label="`Radio ${n}`" :value="n" />
            <v-radio :value="4" disabled label="Radio 4" />
          </v-radio-group>
        </v-col>
      </v-row>
    </section>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/page/design-system/PageLayout.vue"
import IconPigmentsAll from "@/components/icon/pigments/All.vue"

export default {
  components: {
    PageLayout,
    IconPigmentsAll,
  },
  data() {
    return {
      showPassword: false,
      items: [
        { text: "Lorem", value: "lorem" },
        { text: "Ipsum", value: "ipsum" },
      ],
    }
  },
}
</script>
